import { mdiFolderOutline } from '@mdi/js'
import { skipToken } from '@reduxjs/toolkit/dist/query'
import { readRmsHomesHome } from '@racepointenergy/swc/scs/read-rms-homes-home'
import { useParams } from 'react-router-dom'

import { useAppSelector } from 'app/hooks'
import { DomainType } from 'features/domains/types'
import { homeJobSelector } from 'features/home/selectors'
import {
  BreadcrumbsDesktopContainer,
  BreadcrumbBlock,
  BreadcrumbIcon,
  BreadcrumbStatusCircle,
  BreadcrumbHostIconWrapper,
  BreadcrumbsMobileContainer,
  BreadcrumbMobileHomeContainer,
  BreadcrumbMobileHomeTitle,
  BreadcrumbMobileJobTitle,
  BreadcrumbTitle,
} from 'components/Breadcrumbs/styles'
import HostIcon from 'components/HostIcon'
import { Marking } from 'components/Mark'

function getPathToRootDomain(homeJob?: DomainType | null): string[] {
  if (!homeJob) {
    return []
  }

  if (homeJob.job) {
    return getPathToRootDomain(homeJob.parent)
  }

  return [...getPathToRootDomain(homeJob.parent), homeJob.name]
}

function Breadcrumbs(props: {}) {
  const homeJob = useAppSelector(homeJobSelector.data)
  const pathToRootDomain = getPathToRootDomain(homeJob)
  const { homeId: routerHomeId = '' } = (useParams() ?? {}) as {
    homeId?: string
  }
  const skip = !routerHomeId
  const { data: home } = readRmsHomesHome.useQuery(
    skip ? skipToken : { homeId: routerHomeId },
    {
      skip,
    }
  )
  let onlineMarking = Marking.None
  if (home?.online === true) {
    onlineMarking = Marking.Check
  } else if (home?.online === false) {
    onlineMarking = Marking.Error
  }
  return (
    <>
      <BreadcrumbsDesktopContainer>
        {pathToRootDomain.map((domainName) => (
          <BreadcrumbBlock key={domainName}>
            <BreadcrumbTitle>{domainName}</BreadcrumbTitle>
          </BreadcrumbBlock>
        ))}
        {homeJob && (
          <BreadcrumbBlock key={homeJob.id}>
            <BreadcrumbIcon path={mdiFolderOutline} size={0.7} />
            <BreadcrumbTitle>{homeJob.name}</BreadcrumbTitle>
          </BreadcrumbBlock>
        )}
        {home && (
          <BreadcrumbBlock key={home.id}>
            <BreadcrumbStatusCircle marking={onlineMarking} />
            <BreadcrumbHostIconWrapper>
              <HostIcon home={home} size={24} />
            </BreadcrumbHostIconWrapper>
            <BreadcrumbTitle>{home.name}</BreadcrumbTitle>
          </BreadcrumbBlock>
        )}
      </BreadcrumbsDesktopContainer>

      {/* For pending job page we are hiding breadcrumbs on mobile because for better UX */}
      {home && homeJob && (
        <BreadcrumbsMobileContainer>
          <BreadcrumbStatusCircle marking={onlineMarking} />
          <BreadcrumbHostIconWrapper>
            <HostIcon home={home} size={36} />
          </BreadcrumbHostIconWrapper>
          <BreadcrumbMobileHomeContainer>
            <BreadcrumbMobileJobTitle>{homeJob.name}</BreadcrumbMobileJobTitle>
            <BreadcrumbMobileHomeTitle>{home.name}</BreadcrumbMobileHomeTitle>
          </BreadcrumbMobileHomeContainer>
        </BreadcrumbsMobileContainer>
      )}
    </>
  )
}

export default Breadcrumbs
